import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
import { SLIDE_CLASSNAME } from "../constants";
import { getNavigationArrowWidth } from "../utils";
export var CarouselRoot = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var _keenSliderNotDa;
  var isTouchActive = _ref.isTouchActive,
    navigation = _ref.navigation,
    width = _ref.width;
  return _objectSpread(_objectSpread({
    padding: navigation !== null && navigation !== void 0 && navigation.showArrows && navigation.position === 'outside' ? "0 ".concat(getNavigationArrowWidth({
      size: navigation.size
    }), "px") : 0,
    position: 'relative',
    width: width,
    '&:hover .active-pagination-step': {
      animation: 'none'
    }
  }, isTouchActive ? {
    '.active-pagination-step': {
      animation: 'none'
    }
  } : null), {}, {
    '.keen-slider:not([data-keen-slider-disabled])': (_keenSliderNotDa = {
      alignContent: 'flex-start',
      display: 'flex',
      KhtmlUserSelect: 'none',
      msTouchAction: 'pan-y',
      overflow: 'hidden',
      position: 'relative',
      touchAction: 'pan-y',
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      WebkitTouchCallout: 'none',
      width: '100%'
    }, _defineProperty(_keenSliderNotDa, ".".concat(SLIDE_CLASSNAME), {
      minHeight: '100%',
      overflow: 'hidden',
      position: 'relative',
      width: '100%'
    }), _defineProperty(_keenSliderNotDa, '&[data-keen-slider-reverse]', {
      flexDirection: 'row-reverse'
    }), _defineProperty(_keenSliderNotDa, '&[data-keen-slider-v]', {
      flexWrap: 'wrap'
    }), _keenSliderNotDa)
  });
});
export var CarouselInner = styled('div')({
  cursor: 'grab',
  '&:active': {
    cursor: 'grabbing'
  }
});
export var CarouselSlideRoot = styled('div', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref2) {
  var minWidth = _ref2.minWidth;
  return {
    maxWidth: 'fit-content',
    minWidth: minWidth
  };
});
//# sourceMappingURL=root.js.map